export class InputPatterns {
 /** Regex pattern: allows only alphanumeric, commas, and spaces (min 10 chars) */
  public static readonly ADDRESS_PATTERN = '^[a-zA-Z0-9,\\s]+$';

  /** Oninput handler: strips special characters as user types */
  public static readonly ADDRESS_PATTERN_ONINPUT = "this.value = this.value.replace(/[^a-zA-Z0-9,\\s]/g, '');";

  /** Regex pattern: allows only alphabets and commas */
  public static readonly ALPHABETS_COMMA_PATTERN = '^[a-zA-Z,\\s]+$';

  /** Oninput handler: allows only alphabets and commas */
  public static readonly ALPHABETS_COMMA_ONINPUT = "this.value = this.value.replace(/[^a-zA-Z,\\s]/g, '');";

  /** Regex pattern: allows only alphabets (no spaces, no commas) */
  public static readonly ALPHABETS_ONLY_PATTERN = '^[a-zA-Z]+$';

  /** Oninput handler: allows only alphabets (no spaces, no commas) */
  public static readonly ALPHABETS_ONLY_ONINPUT = "this.value = this.value.replace(/[^a-zA-Z]/g, '');";

  /** Regex pattern: allows only alphabets and spaces (no commas) */
  public static readonly ALPHABETS_SPACE_PATTERN = '^[a-zA-Z\\s]+$';

  /** Oninput handler: allows only alphabets and spaces (no commas) */
  public static readonly ALPHABETS_SPACE_ONINPUT = "this.value = this.value.replace(/[^a-zA-Z\\s]/g, '');";

  /** Regex pattern: allows only alphanumeric (letters and numbers, no spaces or special chars) */
  public static readonly ALPHANUMERIC_ONLY_PATTERN = '^[a-zA-Z0-9]+$';

  /** Oninput handler: allows only alphanumeric (letters and numbers, no spaces or special chars) */
  public static readonly ALPHANUMERIC_ONLY_ONINPUT = "this.value = this.value.replace(/[^a-zA-Z0-9]/g, '');";

  /** Regex pattern: allows only valid 10-digit Indian mobile numbers (starts with 6-9) */
  public static readonly MOBILE_INDIA_PATTERN = '^[6-9][0-9]{9}$';

  /** Oninput handler: allows only digits, max 10 characters for Indian mobile */
  public static readonly MOBILE_INDIA_ONINPUT = "this.value = this.value.replace(/[^0-9]/g, '').slice(0, 10);";

  /** Regex pattern: allows only valid 6-digit Indian PIN codes */
  public static readonly PINCODE_INDIA_PATTERN = '^[1-9][0-9]{5}$';

  /** Oninput handler: allows only digits, max 6 characters for Indian PIN code */
  public static readonly PINCODE_INDIA_ONINPUT = "this.value = this.value.replace(/[^0-9]/g, '').slice(0, 6);";

  /** Regex pattern: validates standard email format */
  public static readonly EMAIL_PATTERN = '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$';

  /** Regex pattern: validates Indian PAN card number (e.g., ABCDE1234F) */
  public static readonly PAN_PATTERN = '^[A-Z]{5}[0-9]{4}[A-Z]{1}$';

  /** Oninput handler: allows only valid PAN format characters */
  public static readonly PAN_ONINPUT = "this.value = this.value.replace(/[^A-Z0-9]/g, '').toUpperCase().slice(0, 10);";
}
